import React from "react";
import * as router from "react-router-dom";



import Login from "./Business/Login/LoginIndex.js";
import ParentGroup from "./Business/ProductGroup/ParentGroup.js";
import Brand from "./Business/ProductBrand/AllBrand.js";
import Product from "./Business/Product/Product.js";
import ProductBrand from "./Business/Product/ProductByBrand.js";
import ProductInfo from "./Business/Product/ProductInfo.js";
import Group from "./Business/ProductGroup/Group.js";
import AboutUs from "./Business/AboutUs/AboutUs.js";
import ContactUs from "./Business/ContactUs/ContactUs.js";
import MotorSuggestion from "./Business/Suggestion/MotorSuggestionIndex.js";
import CompareProduct from "./Business/CompareProduct/CompareProductIndex.js";
import FactorHistory from "./Business/Factor/FactorHistoryIndex.js";
import BuyFactorHistory from "./Business/BuyFactor/BuyFactorHistoryIndex.js";
import Basket from "./Business/Basket/BasketIndex.js";
import PaymentFailed from "./Business/Basket/PaymentFailed.js";
import PaymentSuccess from "./Business/Basket/PaymentSuccess.js";
import UserLogin from "./Business/User/UserLogin.js";



function App() {
  

  return (
    
    <router.BrowserRouter forceRefresh={true}>
      <router.Routes>
        <router.Route path="/" element={<Login></Login>} />
        <router.Route path="/Brand" element={<Brand></Brand>} />
        <router.Route path="/AboutUs" element={<AboutUs></AboutUs>} />
        <router.Route path="/ContactUs" element={<ContactUs></ContactUs>} />
        <router.Route path="/ParentGroup" element={<ParentGroup></ParentGroup>} />
        <router.Route path="/MotorSuggestion" element={<MotorSuggestion></MotorSuggestion>} />
        <router.Route path="/CompareProduct" element={<CompareProduct></CompareProduct>} />
        <router.Route path="/Group/:Parent/:Id" element={<Group></Group>} />
        <router.Route path="/Product/:Parent/:Group/:ParentId/:Id" element={<Product></Product>} />
        <router.Route path="/ProductBrand/:Brand/:Id" element={<ProductBrand></ProductBrand>} />
        <router.Route path="/ProductInfo/:Parent/:Group/:Product" element={<ProductInfo></ProductInfo>} />
        <router.Route path="/FactorHistory" element={<FactorHistory></FactorHistory>} />
        <router.Route path="/BuyFactorHistory" element={<BuyFactorHistory></BuyFactorHistory>} />
        <router.Route path="/Basket" element={<Basket></Basket>} />
        <router.Route path="/PaymentFailed" element={<PaymentFailed></PaymentFailed>} />
        <router.Route path="/PaymentSuccess" element={<PaymentSuccess></PaymentSuccess>} />
        <router.Route path="/UserLogin" element={<UserLogin></UserLogin>} />
      </router.Routes>

    </router.BrowserRouter>

  )
}

export default App;